function parseOnlineCount (value) {
  if (value == null) return null
  const count = Number(value)
  if (!Number.isFinite(count) || count < 0) return null
  return Math.floor(count)
}

export function resolveOnlineUserCount (siteInfo) {
  if (!siteInfo) return null

  // 로그인 후 runtime 폴링 값 (실시간 갱신)
  const runtimeCount = parseOnlineCount(siteInfo.gara_user_unt)
  if (runtimeCount != null) return runtimeCount

  // system/info online_cnt — 로그인 전에도 사용 가능
  return parseOnlineCount(siteInfo.online_cnt)
}

export function formatOnlineUserCount (count, locale) {
  const value = Number(count)
  if (!Number.isFinite(value) || value < 0) return '-'
  const lang = String(locale || 'ko').toLowerCase()
  const intlLocale = lang === 'ko' ? 'ko-KR' : lang === 'ja' ? 'ja-JP' : lang === 'zh' ? 'zh-CN' : 'en-US'
  return value.toLocaleString(intlLocale)
}
